// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_features_auction-feature_auctions-toolbar_auctions-toolbar_component_ts-src_a-6324ab":"bfd9360397d4422a","src_app_features_auction-feature_auctions_module_ts":"536d0abba9b34b97","src_app_features_web-feature_web_module_ts":"5fd93ce46e668a7d"}[chunkId] + ".js";
};